import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      
      <section className="pt-32 pb-24" data-testid="privacy-page">
        <div className="max-w-3xl mx-auto px-6 lg:px-12">
          <h1 className="text-4xl font-black uppercase tracking-tighter mb-8">Privacy Policy</h1>
          
          <div className="prose prose-invert prose-sm max-w-none text-white/60">
            <p className="mb-6">Last updated: {new Date().toLocaleDateString()}</p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">1. Information We Collect</h2>
            <p className="mb-4">
              We collect information you provide directly to us, including:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Account information (name, email, password)</li>
              <li>Studio information (business name, address, contact details)</li>
              <li>Images uploaded for wrap visualization</li>
              <li>Payment information (processed securely via Stripe)</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">2. How We Use Your Information</h2>
            <p className="mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions and send related information</li>
              <li>Send technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">3. Data Storage</h2>
            <p className="mb-4">
              Your data is stored securely on servers located in the European Union. 
              We implement appropriate technical and organizational measures to protect your personal data.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">4. Data Sharing</h2>
            <p className="mb-4">
              We do not sell your personal information. We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Service providers who assist in our operations</li>
              <li>Legal authorities when required by law</li>
            </ul>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">5. Your Rights</h2>
            <p className="mb-4">
              You have the right to access, correct, or delete your personal data. 
              Contact us at embermotors@gmail.com to exercise these rights.
            </p>

            <h2 className="text-xl font-bold text-white mt-8 mb-4">6. Contact</h2>
            <p>
              For privacy-related inquiries, contact us at:{' '}
              <a href="mailto:embermotors@gmail.com" className="text-[#FFFFFF] hover:underline">
                embermotors@gmail.com
              </a>
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default PrivacyPage;
